import ApiService from './ApiService'

export const apiTestsList = data => ApiService.get('/inspector/trans-tests', data)
export const apiTestsView = id => ApiService.get(`/inspector/trans-tests${id ? `/${id}` : ''}`)
export const apiTestsStatus = (id, data) => ApiService.post(`/inspector/trans-tests/${id}/status`, data)
